var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1898 11.29C41.5471 11.609 49.8447 20.105 49.8447 30.5396C49.8447 41.1761 41.2224 49.7992 30.5851 49.7992C21.197 49.7992 13.3779 43.0823 11.6719 34.1925C11.544 33.5247 11.4543 32.8918 11.397 32.2016",
    stroke: "white",
    strokeWidth: 3.32233,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0579 27.216C12.9531 27.1381 13.6156 26.3492 13.5377 25.454C13.4598 24.5588 12.6709 23.8963 11.7757 23.9742C10.8805 24.0521 10.2179 24.8409 10.2959 25.7362C10.3738 26.6314 11.1626 27.2939 12.0579 27.216Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7009 21.2541C15.5961 21.1762 16.2587 20.3873 16.1808 19.4921C16.1029 18.5969 15.314 17.9343 14.4188 18.0122C13.5236 18.0902 12.861 18.879 12.9389 19.7743C13.0168 20.6695 13.8057 21.332 14.7009 21.2541Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.22 16.5432C20.1152 16.4653 20.7777 15.6764 20.6998 14.7812C20.6219 13.886 19.833 13.2234 18.9378 13.3013C18.0426 13.3792 17.3801 14.1681 17.458 15.0633C17.5359 15.9585 18.3247 16.6211 19.22 16.5432Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0579 13.5842C25.9531 13.5063 26.6156 12.7174 26.5377 11.8222C26.4598 10.927 25.6709 10.2644 24.7757 10.3423C23.8805 10.4202 23.2179 11.2091 23.2959 12.1043C23.3738 12.9995 24.1626 13.6621 25.0579 13.5842Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.464f3f0e266c794f7c7169c8cacf46f3.svg";
export { ForwardRef as ReactComponent };